import sysAdminImg from "../assets/img/jd-sys-admin.svg";
import beImg from "../assets/img/jd-be.svg";
import feImg from "../assets/img/jd-fe.svg";
import deImg from "../assets/img/jd-de.svg";
import tpmImg from "../assets/img/jd-tpm.svg";
import qaImg from "../assets/img/jd-qa.svg";
import mobileImg from "../assets/img/jd-mobile.svg";
import ceImg from "../assets/img/jd-ce.svg";
import siteImg from "../assets/img/jd-site-reliability.svg";
import { colors } from "../constants";

const requirements = [
  {
    role: "Cybersecurity Engineer",
    description: [
      "Monitor alerts and events using SIEM, EDR, and other monitoring tools.",
      "Support initial triage activities and document security alerts under supervision.",
      "Gather information during incident investigations and contribute to post-incident reviews.",
      "Conduct research on emerging cybersecurity threats, vulnerabilities, and attack trends.",
      "Compile threat intelligence summaries and reports.",
      "Work with infrastructure, engineering, and security teams to support security initiatives.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4826013101",
    icon: sysAdminImg,
    color: colors["lite-lemon"],
  },
  {
    role: "Backend Engineer",
    description: [
      "Translates product requirements into architectural documents and diagrams.",
      "Apply engineering principles to solve complex problems through sound and creative engineering.",
      "Learn new engineering methods and incorporate them into your work processes.",
      "Demonstrates skill in time management and completing software projects in a cooperative team environment.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4024838101",
    icon: beImg,
    color: colors.lavender,
  },
  {
    role: "Data Engineer",
    description: [
      "Work with stakeholders throughout the organization to identify opportunities for leveraging company data to drive business solutions.",
      "Mine and analyze data from company databases to drive optimization and improvement of product development, marketing techniques and business strategies.",
      "Assess the effectiveness and accuracy of new data sources and data gathering techniques.",
      "Develop custom data models and algorithms to apply to data sets.",
      "Use predictive modeling to increase and optimize customer experiences, revenue generation, ad targeting and other business outcomes.",
      "Develop company A/B testing framework and test model quality.",
      "Coordinate with different functional teams to implement models and monitor outcomes",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4304254101",
    icon: deImg,
    color: colors.turquoise,
  },
  {
    role: "Product Manager",
    description: [
      "Work with the engineering team to create and modify products to fulfil customer needs.",
      "Gain a deep understanding of customer experience, identify and fill product gaps and generate new ideas",
      "Work with internal teams, including developers, engineers, architects, quality assurance, and operations",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4304275101",
    icon: tpmImg,
    color: colors.mint,
  },
  {
    role: "Mobile Engineer",
    description: [
      "Assist in developing and improving mobile apps (iOS & Android).",
      "Fix bugs, optimise performance, and maintain the mobile codebase.",
      "Learn and apply industry best practices in mobile development.",
      "Contribute to architectural discussions on scalability, performance, and security.",
      "Collaborate with engineers and participate in team discussions.",
      "Engage in code reviews to enhance code quality.",
      "Support testing and quality assurance efforts.",
      "Contribute to technical documentation.",
      "Help identify and resolve issues during development and deployment.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4553943101",
    icon: mobileImg,
    color: colors["lite-almond"],
  },
  {
    role: "Frontend Engineer",
    description: [
      "Develop high-quality software design and architecture.",
      "Identify, prioritize and execute tasks in the software development life cycle.",
      "Develop tools and applications by producing clean, efficient code.",
      "Applies engineering principles to solve complex problems through sound and creative engineering.",
      "Learn new engineering methods and incorporate them into your work processes.",
      "Demonstrates skill in time management and completing software projects in a cooperative team environment.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4130639101",
    icon: feImg,
    color: colors["powder-blue-gray"],
  },
  {
    role: "Cloud Engineer",
    description: [
      "Assist in the setup, configuration, and maintenance of cloud infrastructure using GCP.",
      "Support the management of Kubernetes clusters, including deployment, scaling, and monitoring.",
      "Contribute to the design and implementation of CI/CD pipelines for automated application deployment.",
      "Work on infrastructure as code (IaC) using tools such as Terraform or Ansible to automate cloud infrastructure provisioning and management.",
      "Collaborate with the development team to ensure seamless integration of applications in the cloud environment.",
      "Contribute to the implementation of monitoring and logging solutions for cloud-based systems.",
      "Participate in security best practices and compliance standards implementation for cloud infrastructure and applications.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4304207101",
    icon: ceImg,
    color: colors["lite-peach"],
  },
  {
    role: "Quality Assurance Engineer",
    description: [
      "Work with other developers, enterprise architects,  product and project managers in designing software solutions.",
      "Perform the different types of tests required to certify the quality of an application before deployment.",
      "Maintains records of bugs captured for applications.",
      "Applies engineering principles to solve complex problems through sound and creative engineering.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4024975101",
    icon: qaImg,
    color: colors["deep-maroon"],
  },
  {
    role: "Site Reliability Engineer",
    description: [
      "Participate in on-call rotations to detect and triage service and reliability issues across all environments.",
      "Create and maintain meaningful dashboards and alerts. Work with development teams to instrument their code to ensure visibility.",
      "Develop automation to eliminate manual and repetitive operational tasks (toil) related to reliability across both applications and infrastructure.",
      "Implement and track Service Level Indicators (SLIs) and Service Level Objectives (SLOs) defined by the engineering leadership.",
      "Investigate and resolve customer complaints escalated beyond L1 and L2 support, especially those involving performance, reliability, or complex system behavior.",
    ],
    applicationLink:
      "https://job-boards.eu.greenhouse.io/moniepoint/jobs/4304243101",
    icon: siteImg,
    color: colors["blush-pink"],
  },
];

export default requirements;
